import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useDeleteSparkStepHelper } from 'stores/sparkBuilderStore';
import { SingleSparkStepResponse } from 'types/SparkStep';
import { fetchWrapper } from 'utils/fetchWrapper';

export function useDeleteSparkStep() {
  const deleteSparkStepHelper = useDeleteSparkStepHelper();

  const deleteSparkStep = (sparkStepID: string | undefined) => {
    if (!sparkStepID) {
      Promise.reject('No Spark Step ID');
    }

    const body = {
      data: {
        id: sparkStepID,
        type: 'sparkSteps',
        attributes: {
          isDeleted: true,
        },
      },
    };

    return fetchWrapper<SingleSparkStepResponse>({
      url: `sparkSteps/${sparkStepID}`,
      method: 'PATCH',
      body: body,
    });
  };

  return useMutation('deleteSparkStep', deleteSparkStep, {
    onMutate: (stepID) => {
      deleteSparkStepHelper.onMutate(stepID || '');
    },
    onSuccess: () => {
      deleteSparkStepHelper.onSuccess();
    },
    onError: (error) => {
      deleteSparkStepHelper.onError();
      if (error instanceof Error) {
        toastr.error(`failed to delete spark step: ${error.message}`);
      }
    },
  });
}
